import { DocumentNode, gql } from '@apollo/client'

export const GET_ALL_SLOTS_CALENDAR_PARENT: DocumentNode = gql`
    query GetAllSlots($from: Date!, $to: Date!, $daycare_id: Int!) {
        getSlots(from: $from, to: $to, daycare_id: $daycare_id) {
            OccasionalSlots {
                id
                daycareId
                sectionId
                childId
                childName
                childComplement
                parentName
                parentId
                section
                parentComment
                date
                start
                end
                type
                matching
                limit {
                    childId
                    limit
                }
                scheduled
                expiry
                created
                updated
                externalNote
                externalIcon
                internalNote
                priorityGroup {
                    id
                    name
                }
                priorityChild {
                    id
                    firstname
                }
                placeId
                placeName
                placeAddress
            }
            RegularSlots {
                id
                daycareId
                childName
                childComplement
                childId
                sectionId
                sectionName
                day
                start
                end
                date
                parentId
                parentName
                absence
                parentComment
                daycareComment
                type
                cancellationRequests {
                    id
                    date
                    start
                    end
                    reason
                    requestDate
                }
                placeId
                placeName
                placeAddress
                created
                updated
            }
            RequestSlots {
                id
                daycareId
                childId
                childName
                childComplement
                sectionName
                comment
                date
                start
                end
                parentId
                parentName
            }
        }
        getClosingDay(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            startDate
            endDate
            closingDaysReason
            closingDaysMessage
        }
        getEventDay(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            date
            startHour
            endHour
            title
            message
            reservation
            places
            attendant
            attendantMin
            sections
            childsMatching {
                childId
                childName
            }
            booked
        }
        getTaskNotesByDaycare(daycareId: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            title
            description
            type
            status
            internalNote
            date
            startHour
            endHour
            userIds {
                id
                name
                isParent
            }
            childIds {
                id
                name
            }
            creationDate
            updateDate
        }
    }
`

export const GET_ALL_SLOTS_CALENDAR_STAFF: DocumentNode = gql`
    query GetAllSlots($from: Date!, $to: Date!, $daycare_id: Int!, $retrieveWorks: Boolean) {
        getSlots(from: $from, to: $to, daycare_id: $daycare_id, retrieveWorks: $retrieveWorks) {
            OccasionalSlots {
                id
                daycareId
                sectionId
                childId
                childName
                childComplement
                parentName
                parentId
                section
                parentComment
                date
                start
                end
                type
                matching
                limit {
                    childId
                    limit
                }
                scheduled
                expiry
                created
                updated
                externalNote
                externalIcon
                internalNote
                priorityGroup {
                    id
                    name
                }
                priorityChild {
                    id
                    firstname
                }
                placeId
                placeName
                placeAddress
            }
            RegularSlots {
                id
                daycareId
                childName
                childComplement
                childId
                sectionId
                sectionName
                day
                start
                end
                date
                parentId
                parentName
                absence
                parentComment
                daycareComment
                type
                cancellationRequests {
                    id
                    date
                    start
                    end
                    reason
                    requestDate
                }
                placeId
                placeName
                placeAddress
                created
                updated
            }
            RequestSlots {
                id
                daycareId
                childId
                childName
                childComplement
                sectionName
                comment
                date
                start
                end
                parentId
                parentName
            }
        }
        getWorks(daycareId: $daycare_id, from: $from, to: $to, retrieveWorks: $retrieveWorks) {
            id
            date
            start
            end
            staff
            staffName
            staffLevelId
            type
            sectionGroupId
            sectionGroupName
            internalNote
            externalNote
            preparationTimeBefore
            preparationTimeAfter
            preparationTasksBefore {
                id
                daycareId
                name
                duration
            }
            preparationTasksAfter {
                id
                daycareId
                name
                duration
            }
            totalDuration
        }
        getClosingDay(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            startDate
            endDate
            closingDaysReason
            closingDaysMessage
        }
        getEventDay(daycare_id: $daycare_id, from: $from, to: $to) {
            id
            daycareId
            date
            startHour
            endHour
            title
            message
            reservation
            places
            attendant
            attendantMin
            sections
            childsMatching {
                childId
                childName
            }
            booked
        }
    }
`
